import { ConvergeTooltip } from '../../../../presentation/components/converge-tooltip';
import { IconButton } from '@mui/material';
import StraightIcon from '@mui/icons-material/Straight';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { useRaterActionDispatchContext } from '../data';

interface ICascadeLimitAndRetentionButton {
  isFirstRow: boolean;
  isLastRow: boolean;
  limit: number | null | undefined;
  retention: number | null | undefined;
  isCyberCrime?: boolean;
}

export const CascadeLimitAndRetentionButton = ({
  isFirstRow,
  isLastRow,
  limit,
  retention,
  isCyberCrime,
}: ICascadeLimitAndRetentionButton) => {
  const { dispatch, actions } = useRaterActionDispatchContext();

  return (
    <ConvergeTooltip title="Cascade limit & retention">
      <IconButton
        onClick={() => {
          !isCyberCrime
            ? dispatch(
                actions.cascadeLimitAndRetention(
                  limit ?? null,
                  retention ?? null
                )
              )
            : dispatch(
                actions.cascadeCyberCrimeLimitAndRetention(
                  limit ?? null,
                  retention ?? null
                )
              );
        }}
      >
        {isFirstRow ? (
          <StraightIcon
            sx={{
              transform: 'rotate(180deg)',
            }}
          />
        ) : isLastRow ? (
          <StraightIcon />
        ) : (
          <SwapVertIcon />
        )}
      </IconButton>
    </ConvergeTooltip>
  );
};
